import { render } from "./NewTicket.vue?vue&type=template&id=5185f412"
import script from "./NewTicket.vue?vue&type=script&lang=js"
export * from "./NewTicket.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5185f412"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5185f412', script)) {
    api.reload('5185f412', script)
  }
  
  module.hot.accept("./NewTicket.vue?vue&type=template&id=5185f412", () => {
    api.rerender('5185f412', render)
  })

}

script.__file = "src/views/support/modules/tickets/NewTicket.vue"

export default script